module.exports = __webpack_public_path__ + "static/media/icon-https.73abd866.svg";